// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__larsseit_cd4cdd', '__larsseit_Fallback_cd4cdd'"},"className":"__className_cd4cdd","variable":"__variable_cd4cdd"};